module.exports = __webpack_public_path__ + "img/product_trading_1200x800.18a28b78.svg";